import React, { Component } from 'react';

import 'css/components/widget/_WidgetError.scss';

export default class WidgetError extends Component {
  render() {
    return <div className="widgetError">Something went wrong, please try again later.</div>;
  }
}
